module.exports = __webpack_public_path__ + "img/cus01.8a05718c.png";